//// filepath: /Users/slgoetz/Code/jcc-nuxt/resources/inline-audio-player.ts
class InlineAudioPlayer {
   private el: HTMLElement;
   private audioEl: HTMLAudioElement | null;
   private player?: HTMLAudioElement;
   private events?: {
      clickInline: (ev: MouseEvent) => void;
   };

   constructor(el: HTMLElement) {
      this.el = el;

      // Attempt to find the <audio> element
      this.audioEl = el.querySelector("audio");
      if (!this.audioEl) return; // No audio element found

      const src = this.audioEl.src;
      if (!src) return; // No src on the <audio> element

      // Create a separate audio player
      this.player = new Audio(src);

      // Bind events
      this.events = {
         clickInline: (ev: MouseEvent) => {
            this.play();
         },
      };
      this.el.addEventListener("click", this.events.clickInline);
   }

   private play() {
      if (!this.player) return;
      this.player.pause();
      this.player.currentTime = 0;
      this.player.volume = 0.7;
      this.player.play().catch((err) => console.warn("inline audio play failed", err));
   }

   //Cleanup method:
   public destroy() {
      this.player?.pause();
      if (this.events?.clickInline) {
         this.el.removeEventListener("click", this.events.clickInline);
      }
   }
}

export default InlineAudioPlayer;
